import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfirmDialog } from './confirm-dialog';

export function showConfirmDialog(
  message: string,
  confirmText?: string,
  cancelText?: string
): Promise<boolean> {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const handleClose = () => {
      root.unmount();
      container.remove();
    };

    root.render(
      React.createElement(ConfirmDialog, {
        message,
        confirmText,
        cancelText,
        onConfirm: (result: boolean) => {
          resolve(result);
        },
        onClose: handleClose,
      })
    );
  });
}
